import { render, staticRenderFns } from "./TransferOrderDetail.vue?vue&type=template&id=75d0b5ef"
import script from "./TransferOrderDetail.vue?vue&type=script&lang=js"
export * from "./TransferOrderDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports